import '../../../sass/pages/account/my_account.scss';
import '../../../sass/pages/account/account_status_panel.scss';
import '../../../sass/components/featured_ads_box.scss';
import '../../../sass/components/featured_ads_upgrade_box.scss';
import '../../../sass/components/verified.scss';
import '../../components/tracking/verified_tracking.js';

import get_boosts from '../my_ads/get_boosts';
import exampleAdvertModal from './ad_example_modal';
import trackEvent from '../../helpers/gtm/eventPush';

get_boosts();
exampleAdvertModal();

const promoCodeHeading = document.querySelector('.promo-code_container h3');
if (promoCodeHeading) {
  promoCodeHeading.addEventListener('click', () => {
    const promoCodeForm = document.querySelector('.promo-form');
    promoCodeForm.style.display = 'inline-flex';
    promoCodeHeading.style.color = '#5E5E5E';
  });
}

const promoCodeClose = document.querySelector('.promo-code-form__close');
if (promoCodeClose) {
  promoCodeClose.addEventListener('click', () => {
    const promoCodeForm = document.querySelector('.promo-form');
    promoCodeForm.style.display = 'none';
    promoCodeHeading.style.color = '#3480DB';
  });
}

const promoCode = document.getElementById('apply-promo-code');
const upgradeButton = document.querySelector('.upgrade-panel__button-main');

const tracking = [
  {
    element: promoCode,
    category: 'upgrade',
    action: 'my_account_enter_promo_code_show',
    label: 'I have a promo code',
  },
  {
    element: upgradeButton,
    category: 'upgrade',
    action: 'upgrade_now',
    label: window.location.href,
  },
];

tracking.forEach((track) => {
  if (track.element) {
    track.element.addEventListener('click', () => {
      trackEvent({
        category: track.category,
        action: track.action,
        label: track.label,
      });
    });
  }
});
